export default "__VITE_PUBLIC_ASSET__312fdee1__"